import { z } from 'zod';
import { ImageOptimizationSchema } from './common.js';
import type { Comment } from '../types/comments.js';

/**
 * Comments endpoint Zod schemas for Polymarket Gamma API
 */

export const ListCommentsParamsSchema = z.object({
  limit: z.number().optional(),
  offset: z.number().optional(),
  order: z.string().optional(),
  ascending: z.boolean().optional(),
  parent_entity_type: z.enum(['Event', 'Series', 'market']).optional(),
  parent_entity_id: z.number().optional(),
  get_positions: z.boolean().optional(),
  holders_only: z.boolean().optional(),
});

export const GetCommentsByIdParamsSchema = z.object({
  id: z.number(),
  get_positions: z.boolean().optional(),
});

export const GetCommentsByUserAddressParamsSchema = z.object({
  user_address: z.string(),
  limit: z.number().optional(),
  offset: z.number().optional(),
  order: z.string().optional(),
  ascending: z.boolean().optional(),
});

export const CommentPositionSchema = z.object({
  tokenId: z.string().nullable().optional(),
  positionSize: z.string().nullable().optional(),
});

export const CommentProfileSchema = z.object({
  name: z.string().nullable().optional(),
  pseudonym: z.string().nullable().optional(),
  displayUsernamePublic: z.boolean().nullable().optional(),
  bio: z.string().nullable().optional(),
  isMod: z.boolean().nullable().optional(),
  isCreator: z.boolean().nullable().optional(),
  proxyWallet: z.string().nullable().optional(),
  baseAddress: z.string().nullable().optional(),
  profileImage: z.string().nullable().optional(),
  profileImageOptimized: ImageOptimizationSchema.optional(),
  positions: z.array(CommentPositionSchema).optional(),
});

export const ReactionSchema = z.object({
  id: z.string(),
  commentID: z.number().nullable().optional(),
  reactionType: z.string().nullable().optional(),
  icon: z.string().nullable().optional(),
  userAddress: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  profile: CommentProfileSchema.optional(),
});

export const CommentSchema: z.ZodType<Comment> = z.lazy(() => z.object({
  id: z.string(),
  body: z.string().nullable().optional(),
  parentEntityType: z.string().nullable().optional(),
  parentEntityID: z.number().nullable().optional(),
  parentCommentID: z.string().nullable().optional(),
  userAddress: z.string().nullable().optional(),
  replyAddress: z.string().nullable().optional(),
  createdAt: z.string().nullable().optional(),
  updatedAt: z.string().nullable().optional(),
  profile: CommentProfileSchema,
  reactions: z.array(ReactionSchema),
  reportCount: z.number().nullable().optional(),
  reactionCount: z.number().nullable().optional(),
}));

export const ListCommentsRequestSchema = ListCommentsParamsSchema;

export const ListCommentsResponseSchema = z.object({
  data: z.array(CommentSchema),
  total: z.number(),
  limit: z.number(),
  offset: z.number(),
});
